import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, createStaticVNode as a, normalizeClass as o, openBlock as s } from "vue";
//#region ../src/icons/agent-assist-color.vue
var c = {
	name: "DtIconAgentAssistColor",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, l = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], u = ["fill"], d = ["fill"], f = ["fill"], p = ["id"], m = ["id"], h = ["id"];
function g(e, t, n, c, g, _) {
	return s(), r("svg", {
		"aria-label": n.ariaLabel,
		class: o([_.iconSizeClass, "d-icon d-icon--agent-assist-color"]),
		"data-qa": _.dataQA,
		"aria-hidden": _.ariaHidden,
		role: "img",
		"data-name": "Agent Assist Color",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		i("path", {
			d: "M2.016 4.917a2.9 2.9 0 0 1 2.9-2.9h6.988a.875.875 0 0 1 0 1.75H4.916a1.15 1.15 0 0 0-1.15 1.15v15.654l3.23-1.946.106-.055a.878.878 0 0 1 .346-.071h11.647a1.15 1.15 0 0 0 1.15-1.148v-5.603a.875.875 0 0 1 1.75 0v5.603a2.9 2.9 0 0 1-2.9 2.898H7.692l-4.35 2.622a.876.876 0 0 1-1.326-.75V4.917Z",
			fill: `url(#${e.uniqueID}a)`
		}, null, 8, u),
		i("path", {
			d: "M11.91 6.94c.129 0 .24.085.279.208a6.17 6.17 0 0 0 4.009 4.034c.126.04.215.157.215.29a.308.308 0 0 1-.215.29 6.171 6.171 0 0 0-3.968 3.907.339.339 0 0 1-.319.234.34.34 0 0 1-.319-.234 6.172 6.172 0 0 0-3.917-3.892.324.324 0 0 1-.226-.306c0-.14.093-.262.226-.306a6.17 6.17 0 0 0 3.958-4.017.293.293 0 0 1 .278-.209Z",
			fill: `url(#${e.uniqueID}b)`
		}, null, 8, d),
		i("path", {
			d: "M18.508 2.385c.086 0 .16.058.185.14a4.114 4.114 0 0 0 2.657 2.703.206.206 0 0 1 .144.195c0 .09-.06.168-.144.196a4.113 4.113 0 0 0-2.63 2.618.226.226 0 0 1-.212.157.226.226 0 0 1-.212-.157 4.114 4.114 0 0 0-2.595-2.608.218.218 0 0 1-.15-.206c0-.094.062-.177.15-.206a4.114 4.114 0 0 0 2.622-2.692c.026-.082.1-.14.185-.14Z",
			fill: `url(#${e.uniqueID}c)`
		}, null, 8, f),
		i("defs", null, [
			i("linearGradient", {
				id: `${e.uniqueID}a`,
				x1: "2.016",
				y1: "2.018",
				x2: "22.969",
				y2: "21.973",
				gradientUnits: "userSpaceOnUse"
			}, [...t[0] || (t[0] = [a("<stop stop-color=\"#471571\"></stop><stop offset=\".031\" stop-color=\"#551B84\"></stop><stop offset=\".145\" stop-color=\"#7C229E\"></stop><stop offset=\".237\" stop-color=\"#9024A4\"></stop><stop offset=\".355\" stop-color=\"#B02290\"></stop><stop offset=\".483\" stop-color=\"#D32B86\"></stop><stop offset=\".603\" stop-color=\"#E92F6F\"></stop><stop offset=\".701\" stop-color=\"#F6484F\"></stop><stop offset=\".9\" stop-color=\"#FB7328\"></stop><stop offset=\".973\" stop-color=\"#F3960F\"></stop><stop offset=\"1\" stop-color=\"#F3960F\"></stop>", 11)])], 8, p),
			i("linearGradient", {
				id: `${e.uniqueID}b`,
				x1: "7.449",
				y1: "6.939",
				x2: "16.413",
				y2: "15.903",
				gradientUnits: "userSpaceOnUse"
			}, [...t[1] || (t[1] = [a("<stop stop-color=\"#471571\"></stop><stop offset=\".031\" stop-color=\"#551B84\"></stop><stop offset=\".145\" stop-color=\"#7C229E\"></stop><stop offset=\".237\" stop-color=\"#9024A4\"></stop><stop offset=\".355\" stop-color=\"#B02290\"></stop><stop offset=\".483\" stop-color=\"#D32B86\"></stop><stop offset=\".603\" stop-color=\"#E92F6F\"></stop><stop offset=\".701\" stop-color=\"#F6484F\"></stop><stop offset=\".9\" stop-color=\"#FB7328\"></stop><stop offset=\".973\" stop-color=\"#F3960F\"></stop><stop offset=\"1\" stop-color=\"#F3960F\"></stop>", 11)])], 8, m),
			i("linearGradient", {
				id: `${e.uniqueID}c`,
				x1: "15.551",
				y1: "2.385",
				x2: "21.56",
				y2: "8.327",
				gradientUnits: "userSpaceOnUse"
			}, [...t[2] || (t[2] = [a("<stop stop-color=\"#471571\"></stop><stop offset=\".031\" stop-color=\"#551B84\"></stop><stop offset=\".145\" stop-color=\"#7C229E\"></stop><stop offset=\".237\" stop-color=\"#9024A4\"></stop><stop offset=\".355\" stop-color=\"#B02290\"></stop><stop offset=\".483\" stop-color=\"#D32B86\"></stop><stop offset=\".603\" stop-color=\"#E92F6F\"></stop><stop offset=\".701\" stop-color=\"#F6484F\"></stop><stop offset=\".9\" stop-color=\"#FB7328\"></stop><stop offset=\".973\" stop-color=\"#F3960F\"></stop><stop offset=\"1\" stop-color=\"#F3960F\"></stop>", 11)])], 8, h)
		])
	], 10, l);
}
var _ = /* @__PURE__ */ n(c, [["render", g]]);
//#endregion
export { _ as default };

//# sourceMappingURL=agent-assist-color.js.map